export function Brandmark({ size = 28 }: { size?: number }) {
  return (
    <div
      className="flex items-center justify-center bg-ink text-canvas rounded-md shadow-whisper"
      style={{ width: size, height: size }}
    >
      <span className="font-serif italic" style={{ fontSize: Math.round(size * 0.72), lineHeight: 1 }}>R</span>
    </div>
  );
}

export function Wordmark({ className = "" }: { className?: string }) {
  return (
    <span className={`font-serif text-ink leading-none ${className}`}>
      Route<span className="italic text-accent">flow</span>
    </span>
  );
}
